import { createContext } from 'react';

export const InitialDataContext = createContext(null);
